var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.watchlist && !_vm.virtualLog
    ? _c(
        "div",
        {
          staticClass:
            "active-watchlist-selector q-pt-sm q-px-md row justify-between"
        },
        [
          _c(
            "router-link",
            {
              attrs: {
                to: {
                  name: "watchlistDetail",
                  params: { id: _vm.watchlist.uid, watchlist: _vm.watchlist }
                }
              }
            },
            [_vm._v(_vm._s(_vm.watchlist.name))]
          ),
          _vm._v(" "),
          _vm.watchlist.customerName
            ? _c("span", [_vm._v(_vm._s(_vm.watchlist.customerName))])
            : _vm._e(),
          _vm._v(" "),
          _vm.watchlist.totalArea
            ? _c("span", [
                _vm._v(_vm._s(_vm._f("area")(_vm.watchlist.totalArea)))
              ])
            : _vm._e()
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }